import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Label, Input, FormFeedback, FormGroup } from 'reactstrap'
import { Field, ErrorMessage } from 'formik'
import _ from 'lodash'
import { USE_SITE_MERGE_TOOL_LINK } from './EditSiteModal/constants'

const FormikInputField = props => {
  const error = _.get(props.errors, props.name)
  const isInvalid = error && _.get(props.touched, props.name)
  const isDisabled = props.disabled || props.isSubmitting

  const useSiteMergeToolLink = () =>
    error && error.includes(USE_SITE_MERGE_TOOL_LINK) ? (
      <Link to="/css-admin/utilities">Site Merge Tool</Link>
    ) : null

  return (
    <FormGroup className={props.className}>
      {(props.label || props.children) && (
        <Label>{props.label || props.children}</Label>
      )}
      <Input
        data-testid={props.dataTestId}
        disabled={isDisabled}
        id={props.id}
        invalid={isInvalid}
        name={props.name}
        readOnly={isDisabled}
        tag={Field}
        type={props.type}
        validate={props.validate}
      />
      <FormFeedback>
        {error}
        {useSiteMergeToolLink()}
      </FormFeedback>
    </FormGroup>
  )
}

FormikInputField.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  dataTestId: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'number', 'date', 'hidden']).isRequired,
  validate: PropTypes.func,
}

FormikInputField.defaultProps = {
  type: 'text',
  readOnly: false,
}

export default FormikInputField



// WEBPACK FOOTER //
// ./src/components/FormikInputField.js